const DisplayErrorMessage = ({ text }) => (
  <div className="flex">
    <div className="flex bg-light-rose-500 p-2 rounded-lg mt-4 text-sm">
      <p className="h-[25px] w-[25px] text-xl text-white text-center bg-rose-500 rounded-full mr-4 my-auto">
        !
      </p>

      <p className="text-rose-500 my-auto">{text}</p>
    </div>
  </div>
);

export default DisplayErrorMessage;
